import React from "react";
import { Box, Typography, TextField } from "@mui/material";
import { FormattedMessage, useIntl } from "react-intl";

function OpenTextQuestion({ question, index, handleQuestionChange, isDeleting }) {
  const intl = useIntl();

  return (
    <Box>
      {/* Response Preview */}
      <Typography
        variant="body2"
        sx={{ mb: 1, fontSize: "0.875rem", color: "text.secondary" }}
      >
        <FormattedMessage id="survey.open_text.label" />
      </Typography>
      <TextField
        placeholder={intl.formatMessage({ id: "survey.open_text.placeholder" })}
        fullWidth
        disabled
        variant="outlined"
        size="small"
        sx={{
          "& .MuiOutlinedInput-root": {
            borderRadius: "4px",
            backgroundColor: "#f5f5f5",
          },
        }}
      />
    </Box>
  );
}

export default OpenTextQuestion;
